import network from 'lib/utils/network';
import channelService from 'lib/services/channelService';
import { API } from './constants';

// 获取我的奖励列表
export const getUserPrizeList = ({ actIdList, mobile }) => network.request({
  url: API.COMMON_PRIZE_LIST,
  method: 'POST',
  data: {
    actIdList,
    mobile,
  },
  isNodeApi: true,
});

// 获取碎片消耗列表
export const getUsedFragmentList = ({ offset, limit, createTime = '' }) => network.request({
  url: API.USED_FRAGMENT_PRIZE_LIST,
  method: 'POST',
  data: {
    offset,
    limit,
    createTime,
  },
  isNodeApi: true,
});

// 获取我的碎片列表
export const getUnusedFragmentList = () => network.request({
  url: API.UNUSED_FRAGMENT_PRIZE_LIST,
  method: 'POST',
  data: {
    limit: 99,
    offset: 0,
  },
  isNodeApi: true,
});


// 合成奖励发奖接口
export const awardFusionPrize = params => network.request({
  url: API.AWARD_FUSION_PRIZE,
  method: 'POST',
  data: {
    channel: channelService.gameCode,
    platId: params.amsSystemId,
    area: params.amsChannelId,
    partition: params.amsPartitionId,
    roleId: params.roleId,
    roleName: params.roleName,
    lotteryId: params.lotteryId,
    obdToken: params.obdToken, // q币领取的qqtoken
    qqUin: params.qqUin, // cash qq领取
    fusionPrizeRecordId: params.fusionPrizeRecordId,  // 合成奖励活动id
  },
  isNodeApi: true,
});

// 合成的实物奖励发奖接口
export const awardPhysicalGift = ({ fusionPrizeRecordId, addressInfo }) => network.request({
  url: API.AWARD_PHYSICAL_GIFT,
  method: 'POST',
  data: {
    channel: channelService.gameCode,
    fusionPrizeRecordId,
    addressInfo,
  },
  isNodeApi: true,
});

export const getPrizeDetail = prizeId => network.request({
  url: API.PRIZE_DETAIL,
  method: 'POST',
  data: {
    prizeId,
  },
  isNodeApi: true,
});

export const getSignInTask = activityId => network.request({
  url: API.SIGN_IN_TASK,
  method: 'POST',
  data: {
    activityId: Number(activityId),
  },
  isNodeApi: true,
});

export const getActivityInfoConfig = (activityId) => network.request({
  url: API.ACTIVITY_DETAIL,
  method: 'POST',
  data: {
    activityId,
  },
  isNodeApi: true,
});
